var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.dropdown ? 'b-dropdown-item' : 'b-button',{tag:"component",attrs:{"disabled":_vm.running,"variant":_vm.action.variant},on:{"click":_vm.performAction}},[_c('i',{staticClass:"bx",class:( _obj = {}, _obj[_vm.action.icon] = true, _obj['bx-flashing'] =  _vm.running, _obj )}),_vm._v(" "+_vm._s(_vm.$t(_vm.action.label || ((_vm.resource.plural) + ".actions." + (_vm.action.name))))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }